import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "dropdown", "hiddenField", "option", "noResults", "chevron"]
  static values = { open: Boolean }

  connect() {
    this.openValue = false
    this.boundClose = this.closeOnClickOutside.bind(this)
    document.addEventListener("click", this.boundClose)
  }

  disconnect() {
    document.removeEventListener("click", this.boundClose)
  }

  filter() {
    const query = this.inputTarget.value.toLowerCase()
    let visibleCount = 0

    this.optionTargets.forEach(option => {
      const text = option.dataset.label.toLowerCase()
      const match = query === "" || text.includes(query)
      option.classList.toggle("hidden", !match)
      if (match) visibleCount++
    })

    // Show/hide "no results" message
    if (this.hasNoResultsTarget) {
      this.noResultsTarget.classList.toggle("hidden", visibleCount > 0)
    }

    this.show()
  }

  select(event) {
    const option = event.currentTarget
    this.inputTarget.value = option.dataset.label
    this.hiddenFieldTarget.value = option.dataset.value
    this.hiddenFieldTarget.dispatchEvent(new Event('change', { bubbles: true }))
    this.hide()
  }

  clear() {
    this.inputTarget.value = ""
    this.hiddenFieldTarget.value = ""
    this.hiddenFieldTarget.dispatchEvent(new Event('change', { bubbles: true }))
    this.filter()
  }

  toggleDropdown(event) {
    event.stopPropagation()
    if (this.openValue) {
      this.hide()
    } else {
      // Reset filter to show all
      this.optionTargets.forEach(option => option.classList.remove("hidden"))
      if (this.hasNoResultsTarget) this.noResultsTarget.classList.add("hidden")
      this.show()
      this.inputTarget.focus()
      this.inputTarget.select()
    }
  }

  showDropdown() {
    this.optionTargets.forEach(option => option.classList.remove("hidden"))
    if (this.hasNoResultsTarget) this.noResultsTarget.classList.add("hidden")
    this.show()
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hide()
    }
  }

  // Private

  show() {
    this.dropdownTarget.classList.remove("hidden")
    this.openValue = true
    if (this.hasChevronTarget) this.chevronTarget.classList.add("rotate-180")
  }

  hide() {
    this.dropdownTarget.classList.add("hidden")
    this.openValue = false
    if (this.hasChevronTarget) this.chevronTarget.classList.remove("rotate-180")
  }
}
